import React from 'react';
import './navbar.css';

export default function Navbar(){
  return (
    <div className="heading">
    <h1>Music on Maps Playlist!</h1>
    </div>
  );
}